import React, { FC } from 'react';

import './Range.styles.css';
import { RangeProps } from '~/core/dto/components/rangeDTO';

const getColor = ( progress: number ) => {

  if ( progress <= 0.15 ) {

    return '#D63C32';

  }

  if ( progress <= 0.35 ) {

    return '#F76421';

  }

  if ( progress <= 0.5 ) {

    return '#EA8C26';

  }

  if ( progress <= 0.7 ) {

    return '#F0D024';

  }

  if ( progress <= 0.85 ) {

    return '#C5ED25';

  }

  return '#98DE24';

};

const Range: FC<RangeProps> = ( { progress = 1, isGradient, label } ) => (
  <div>
    <div className="rangeContainer">
      <div className={`rangeContainerFill${isGradient ? ' gradient' : ''}`} style={{ width: `${isGradient ? 100 : Math.round( progress * 100 )}%` }}>
        <div className="rangeValue" style={isGradient ? { left: `${Math.round( ( progress ) * 100 )}%`, borderColor: getColor( progress ) } : {}}>
          <div className="rangeValueCenter" style={isGradient ? { backgroundColor: getColor( progress ) } : {}} />
        </div>
        {Boolean( label ) && (
        <div
          className={`rangeLabel${progress > 0.5 ? ' reversed' : ''}`}
          style={progress > 0.5
            ? { right: `${Math.round( ( 1 - progress ) * 100 )}%` }
            : { left: `${Math.round( ( progress ) * 100 )}%` }}
        >
          {label}
        </div>
        )}
      </div>
    </div>
    {Boolean( label ) && <div className="rangeLabelSpacer" />}
  </div>
);

export default Range;
